export default __webpack_public_path__ + "static/media/pixnew.76eec667.svg";